import { alertConstants } from '../_constants';

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.HIDE:
      return {
        show: false,
        type: action.variant
      };
    case alertConstants.SUCCESS:
      return {
        show: true,
        type: 'success',
        message: action.message,
      };
    case alertConstants.ERROR:
      return {
        show: true,
        type: 'error',
        message: action.message
      };
    case alertConstants.WARNING:
      return {
        show: true,
        type: 'warning',
        message: action.message
      };
    // Jeino
    case alertConstants.INFO:
      return {
        show: true,
        type: 'info',
        message: action.message,
        hideDuration: action.hideDuration,
      };
    default:
      return state
  }
}